import { AutogenModelInvoiceProcessingProfile, AutogenRowInvoiceProcessingProfile } from "./autogen/AutogenModelInvoiceProcessingProfile";

export class ModelInvoiceProcessingProfile extends AutogenModelInvoiceProcessingProfile<RowInvoiceProcessingProfile> {
	constructor() {
		super(RowInvoiceProcessingProfile);
	}
}

export class RowInvoiceProcessingProfile extends AutogenRowInvoiceProcessingProfile {
}